/* eslint-disable max-len */
import React from 'react'

import { string } from 'prop-types'

function PriceBetween(props) {
  return (
    <svg {...props} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.1023 16.5049C15.6065 16.5562 15.9998 16.9823 15.9998 17.5C15.9998 18.0177 15.6065 18.4438 15.1023 18.4951L14.9998 18.5H4.9998C4.4477 18.4998 3.9998 18.0521 3.9998 17.5C3.9998 16.9479 4.4477 16.5002 4.9998 16.5H14.9998L15.1023 16.5049ZM13.3328 6.08301C13.6363 6.08301 13.9243 6.22114 14.1141 6.45801L17.4471 10.625C17.6805 10.9168 17.7316 11.3148 17.5799 11.6562L15.9139 15.4062C15.7533 15.7672 15.3949 16 14.9998 16H4.9998C4.56954 15.9998 4.18762 15.7236 4.05155 15.3154L2.80155 11.5654C2.69464 11.2439 2.75693 10.8897 2.96855 10.625L6.30253 6.45801L6.38066 6.37109C6.57433 6.17995 6.8397 6.07531 7.11503 6.08398C7.42973 6.09406 7.72146 6.25193 7.90214 6.50977L10.0525 9.58105L12.5525 6.45801L12.6277 6.37402C12.8138 6.18883 13.0673 6.0832 13.3328 6.08301ZM10.781 11.874C10.5843 12.12 10.2824 12.2591 9.96757 12.249C9.65296 12.2387 9.36099 12.0811 9.18046 11.8232L7.02909 8.75L4.86991 11.4492L5.7205 14H14.3494L15.5057 11.3984L13.3328 8.68359L10.781 11.874ZM6.66679 1.66699C7.58715 1.66699 8.33361 2.41268 8.33378 3.33301C8.33378 4.25348 7.58726 5 6.66679 5C5.74636 4.99995 4.9998 4.25345 4.9998 3.33301C4.99997 2.41271 5.74646 1.66704 6.66679 1.66699ZM13.3338 1.66699C14.254 1.66712 14.9996 2.41276 14.9998 3.33301C14.9998 4.2534 14.2541 4.99987 13.3338 5C12.4133 5 11.6668 4.25348 11.6668 3.33301C11.667 2.41268 12.4134 1.66699 13.3338 1.66699Z"
        fill="#35424F"
      />
    </svg>
  )
}

PriceBetween.propTypes = {
  className: string,
  height: string,
  width: string,
}

export default PriceBetween
